/* eslint-disable radix */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';

const store = createStore({
    state: {
        globalloading: false,
        showCartModal: false,
        showCheckout: false,
        showCatalogueCheckout: false,
        showFavouritesList: false,
        showLogoCheckout: false,
        currentMeasure: null,
        currentLogo: null,
        cart: [],
        catalogueCart: [],
        favourites: [],
        localRegistrants: [],
        switchWidths: [],
        selectedTopics: {},
        api: axios.create({
            baseURL: baytmns.rootapiurl,
            headers: {
                'content-type': 'application/json',
                // 'X-WP-Nonce': baytmns.nonce
            },
        }),
    },
    actions: {
        async setMeasure({ commit }, measure) {
            commit('mutateSetMeasure', measure);
        },
        async unsetMeasure({ commit }) {
            commit('mutateUnsetMeasure');
        },
        async setLogo({ commit }, logo) {
            commit('mutateSetLogo', logo);
        },
        removeMeasure({ commit }, measureId) {
            commit('mutateRemoveMeasure', measureId);
        },
        unsetMeasureId({ commit }) {
            commit('mutateUnsetMeasureId');
        },
        addItemToCart({ commit }, item) {
            commit('mutateAddItemToCart', item);
        },
        addMeasureToFavourites({ commit }, measure) {
            commit('mutateAddMeasureToFavourites', measure);
        },
        removeMeasureFromFavourites({ commit }, measureId) {
            commit('mutateRemoveMeasureFromFavourites', measureId);
        },
        clearFavourites({ commit }) {
            commit('mutateClearFavourites');
        },
        addCatalogueToCart({ commit }, item) {
            commit('mutateAddCatalogueItemToCart', item);
        },
        resetCart({ commit }) {
            commit('mutateResetCart');
        },
        resetCatalogueCart({ commit }) {
            commit('mutateResetCatalogueCart');
        },
        resetCurrentLogo({ commit }) {
            commit('mutateResetCurrentLogo');
        },
        showCartModal({ commit }) {
            commit('mutateShowCartModal');
            commit('mutateHideFavouritesList');
            commit('mutateSetCheckoutVisibility', false);
            commit('mutateSetCatalogueCheckoutVisibility', false);
            commit('mutateSetLogoCheckoutVisibility', false);
        },
        hideCartModal({ commit }) {
            commit('mutateHideCartModal');
        },
        showFavouritesList({ commit }) {
            commit('mutateShowFavouritesList');
            commit('mutateSetCheckoutVisibility', false);
            commit('mutateSetCatalogueCheckoutVisibility', false);
            commit('mutateSetLogoCheckoutVisibility', false);
        },
        hideFavouritesList({ commit }) {
            commit('mutateHideFavouritesList');
        },
        setCheckoutVisibility({ commit }, payload) {
            commit('mutateSetCheckoutVisibility', payload);
            commit('mutateHideFavouritesList');
            if (payload) {
                commit('mutateHideCartModal');
                commit('mutateSetCatalogueCheckoutVisibility', false);
                commit('mutateSetLogoCheckoutVisibility', false);
            }
        },
        setCatalogueCheckoutVisibility({ commit }, payload) {
            commit('mutateSetCatalogueCheckoutVisibility', payload);
            commit('mutateHideFavouritesList');
            if (payload) {
                commit('mutateHideCartModal');
                commit('mutateSetCheckoutVisibility', false);
                commit('mutateSetLogoCheckoutVisibility', false);
            }
        },
        setLogoCheckoutVisibility({ commit }, payload) {
            commit('mutateSetLogoCheckoutVisibility', payload);
            commit('mutateHideFavouritesList');
            if (payload) {
                commit('mutateHideCartModal');
                commit('mutateSetCheckoutVisibility', false);
                commit('setCatalogueCheckoutVisibility', false);
            }
        },
        addSwitchWidth({ commit }, payload) {
            commit('mutateAddSwitchWidth', payload);
        },
        createSelectedTopics({ commit }, payload) {
            commit('createSelectedTopics', payload);
        },
        setTopic({ commit }, payload) {
            commit('mutateSetTopic', payload);
        },
    },
    mutations: {
        mutateStartLoading(state) {
            state.globalloading = true;
        },
        mutateStopLoading(state) {
            state.globalloading = false;
        },
        mutateSetMeasure(state, measure) {
            state.currentMeasure = measure;
        },
        mutateUnsetMeasure(state) {
            state.currentMeasure = null;
        },
        mutateSetLogo(state, logo) {
            state.currentLogo = logo;
        },
        mutateRemoveMeasure(state, measureId) {
            state.cart = state.cart.filter(
                (item) => item.measure.id !== measureId
            );
        },
        mutateUnsetMeasureId(state) {
            state.measureId = null;
        },
        mutateAddItemToCart(state, item) {
            if (!state.cart.some((el) => el.measure.id === item.measure.id)) {
                state.cart.push(item);
            } else {
                const itemIndex = state.cart.findIndex(
                    (i) => i.measure.id === item.measure.id
                );
                state.cart[itemIndex] = item;
            }
        },
        mutateAddMeasureToFavourites(state, id) {
            state.favourites.push(id);
        },
        mutateRemoveMeasureFromFavourites(state, id) {
            const index = state.favourites.findIndex((e) => e.id === id);
            if (index > -1) {
                state.favourites.splice(index, 1); // 2nd parameter means remove one item only
            }
        },
        mutateClearFavourites(state) {
            state.favourites = [];
        },
        mutateUpdateCatalogueAmount(state, item) {
            if (
                !state.catalogueCart.some(
                    (el) => el.catalogueId === item.catalogueId
                )
            ) {
                state.catalogueCart.push(item);
            } else {
                const itemIndex = state.catalogueCart.findIndex(
                    (i) => i.catalogueId === item.catalogueId
                );
                state.catalogueCart[itemIndex] = item;
            }
        },
        mutateRemoveCatalogueItem(state, itemId) {
            const index = state.catalogueCart.findIndex(
                (i) => i.catalogueId === itemId
            );
            if (index !== -1) {
                state.catalogueCart.splice(index, 1);
            }
        },
        mutateResetCart(state) {
            state.cart = [];
        },
        mutateResetCatalogueCart(state) {
            state.catalogueCart = [];
        },
        mutateResetCurrentLogo(state) {
            state.currentLogo = null;
        },
        mutateShowCartModal(state) {
            state.showCartModal = true;
        },
        mutateHideCartModal(state) {
            state.showCartModal = false;
        },
        mutateShowFavouritesList(state) {
            state.showFavouritesList = true;
            document.body.style.overflow = 'hidden';
        },
        mutateHideFavouritesList(state) {
            state.showFavouritesList = false;
            document.body.style.overflow = 'auto';
        },
        mutateSetCheckoutVisibility(state, payload) {
            state.showCheckout = payload;
        },
        mutateSetCatalogueCheckoutVisibility(state, payload) {
            state.showCatalogueCheckout = payload;
        },
        mutateSetLogoCheckoutVisibility(state, payload) {
            state.showLogoCheckout = payload;
        },
        mutateAddRegistrant(state, payload = []) {
            // payload = addfields
            const registrant = {
                company: '',
                salutation: 'Anrede',
                firstname: '',
                lastname: '',
                street: '',
                postalcode: '',
                city: '',
                country: '',
                email: '',
                phone: '',
            };
            payload.forEach((ad) => {
                registrant[ad.label.slugify()] = {
                    value: '',
                    addField: true,
                    label: ad.label,
                };
            });
            state.localRegistrants.push(registrant);
        },
        mutateAddSwitchWidth(state, payload) {
            const index = state.switchWidths.findIndex(
                (o) => o.id === payload.id
            );
            if (index > -1) {
                state.switchWidths[index] = { widht: payload.width };
            } else {
                state.switchWidths.push(payload);
            }
        },
        createSelectedTopics(state, payload) {
            // For each slider, create an entry with the parent ID.
            // Also add a status for 1.left / 2.Neutral (default) / 3.right and is neutral point.
            if (state.selectedTopics.hasOwnProperty(payload.parent)) return;

            state.selectedTopics[payload.parent] = {};
            state.selectedTopics[payload.parent][payload.term_id_1] = {};
            state.selectedTopics[payload.parent][payload.term_id_2] = {};
            state.selectedTopics[payload.parent][payload.term_id_3] = {};
            state.selectedTopics[payload.parent][payload.term_id_1].status = false;
            state.selectedTopics[payload.parent][payload.term_id_1].neutral = false;
            state.selectedTopics[payload.parent][payload.term_id_2].status = true;
            state.selectedTopics[payload.parent][payload.term_id_2].neutral = true;
            state.selectedTopics[payload.parent][payload.term_id_3].status = false;
            state.selectedTopics[payload.parent][payload.term_id_3].neutral = false;
        },
        mutateSetTopic(state, payload) {
            if (!state.selectedTopics.hasOwnProperty(payload.parent)) return;

            const childObject = state.selectedTopics[payload.parent];
            childObject[payload.term_id].status = true;
            for (const key of Object.keys(childObject)) {
                if (parseInt(key) !== payload.term_id) {
                    childObject[key].status = false;
                }
            }
        },
    },
    getters: {
        allLocalRegistrants(state) {
            return state.localRegistrants;
        },
        switchMinWidth(state) {
            if (
                Array.isArray(state.switchWidths)
                && state.switchWidths.length
            ) {
                // return `${
                //     state.switchWidths.reduce((max, sw) => (max.width > sw.width ? max : sw)).width
                // }px`;
                return state.switchWidths.reduce((max, sw) => (max.width > sw.width ? max : sw)).width;
            }
            return 0;
        },
        selectedTopics(state) {
            return state.selectedTopics;
        },
    },
    plugins: [
        createPersistedState({
            key: 'baytmstore',
            paths: ['cart', 'catalogueCart', 'currentLogo', 'favourites'],
        }),
    ],
});

export default store;
